import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiMenu, FiX } from 'react-icons/fi';
import { useCountry } from './CountryContext';
import '../styles/Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // const { country } = useParams();
  const { code } = useCountry();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Also toggle body scroll to prevent scrolling behind the menu
    document.body.style.overflow = !isMenuOpen ? 'hidden' : '';
  };

  // Close menu when clicking a link (for mobile)
  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = '';
  };

  // Helper function to generate country-specific links
  const getCountryPath = (path) => {
    return code ? `/${code}${path}` : path;
  };

  return (
    <nav className={`navbar ${isMenuOpen ? 'menu-open' : ''}`}>
      <div className="navbar-container">
        <Link 
          to={getCountryPath('/')} 
          className="navbar-brand" 
          onClick={closeMenu}
        >
          <FiMail />
          Quick Inbox
        </Link>
        
        <button 
          className="mobile-menu-button" 
          onClick={toggleMenu} 
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          {isMenuOpen ? <FiX /> : <FiMenu />}
        </button>
        
        <div className={`nav-links ${isMenuOpen ? 'nav-active' : ''}`}>
          <Link 
            to={getCountryPath('/')} 
            className="nav-link" 
            onClick={closeMenu}
          >
            Home
          </Link>
          <Link 
            to={getCountryPath('/blog')} 
            className="nav-link" 
            onClick={closeMenu}
          >
            Blog
          </Link>
          <Link 
            to={getCountryPath('/faq')} 
            className="nav-link" 
            onClick={closeMenu}
          >
            FAQ
          </Link>
          <Link 
            to={getCountryPath('/privacy')} 
            className="nav-link" 
            onClick={closeMenu}
          >
            Privacy
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 